import { IGenesysWebMessagingConfiguration } from "@auvious/integrations";

export interface IApplicationDTO {
  id?: string;
  organizationId?: string;
  createdAt?: string;
  version?: number;
  type: ApplicationTypeEnum;
  config: IApplicationConfig;
}

export enum ApplicationTypeEnum {
  Genesys = "GENESYS",
  StandaloneOpenID = "STANDALONE_OPENID",
  Customer = "CUSTOMER",
  Test = "TEST",
  SetupTest = "SETUP_TEST",
  TalkdeskOpenID = "TALKDESK_OPENID",
}

export interface IApplicationConfig {
  publicParameters?: IApplicationPublicParams;
  // serviceParameters?: IApplicationServiceParams;
  // agentParameters?: IApplicationAgentParams;
  // customerParameters?: IApplicationCustomerParams;
  admins?: string[];
  supervisors?: string[];
}

// eslint-disable-next-line no-shadow
export enum PublicParam {
  // THEME = "theme",
  VIDEO_SELFIE_QUALITY = "videoSelfieQuality",
  VIDEO_ENVIRONMENT_QUALITY = "videoEnvironmentQuality",
  VIDEO_SCREEN_SHARE_QUALITY = "videoScreenShareQuality",
  CUSTOM_DOMAIN_URL = "customDomainURL",
  GENESYS_WEB_MESSAGING_CONFIG = "genesysWebMessagingConfig",
  TICKET_GROUPS_ENABLED = "ticketGroupsEnabled",
  TICKET_LENGTH = "ticketLength",
}

export interface IApplicationPublicParams {
  // [PublicParam.THEME]?: IThemeOptions;
  [PublicParam.VIDEO_SELFIE_QUALITY]?: number;
  [PublicParam.VIDEO_ENVIRONMENT_QUALITY]?: number;
  [PublicParam.VIDEO_SCREEN_SHARE_QUALITY]?: number;
  [PublicParam.CUSTOM_DOMAIN_URL]?: string;
  [PublicParam.GENESYS_WEB_MESSAGING_CONFIG]?: IGenesysWebMessagingConfiguration;
  [PublicParam.TICKET_GROUPS_ENABLED]?: boolean;
  [PublicParam.TICKET_LENGTH]?: number;
}
